import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
    TextField,
    DatePicker,
} from "react-md";
import moment from 'moment';
import calendar from '../../../assets/images/search-result/calendar.svg';
import {CREATE, DATE_FORMAT} from './../constants';
import { CALENDER_DATE_FORMAT, DATE_PICKER_DATE_FORMAT } from '../../../settings';
import blueTick from '../../../assets/images/common/blueTick.svg';
import greenTick from '../../../assets/images/common/okGreen.svg';
import { push } from 'connected-react-router';
import { notification } from 'antd';
import { updateURLParameter } from '../../SpaceListing/Common/Common';

const SingleDatePicker = ({ selectedDate, label, minDate, onChange, availableDates, value, blockType=CREATE, setPreviousDates, urlUpdate=true }) => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const locationPath = useSelector((state) => state?.router?.location?.pathname || '');
    const [verified, setVerify] = useState(false);
    const searchURLString = useSelector((state) => state?.router?.location?.search || "");

    const handleClearAll = () => {
        setVisible(false);
        let selectedDate = null;

        for(let x=0; x <= 90; x++){
            availableDates.forEach(value => {
                if(!selectedDate) {
                    if (value?.[moment().add(x, 'days').format("YYYY-MM-DD") + "T00:00:00.000+0000"]?.status) {
                        selectedDate = moment().add(x, 'days').format(DATE_PICKER_DATE_FORMAT);
                    }
                }
            })
            if(selectedDate)
                break;
        }
        blockType===CREATE?onChange(selectedDate):setPreviousDates();
    }

    const getDateClassName = date => {
        const calendarDate = moment(date).format('L');
        const today = moment().format('L');
        const available = availableDates.find(availDate => {
            const [checkingDate] = Object.keys(availDate);
            if (availDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
                `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` === checkingDate)
                return availDate[checkingDate];
        });

        const isToday = calendarDate === today;

        if (!available) {
            return 'disable-date'
        } else if (available && !available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].status) {
            return 'disable-date'
        } else if (isToday) {
            return 'current-date';
        }
        return null;
    };

    const dateRenderer = (date, day) => {
        const available = availableDates.find(availDate => {
            const [ checkingDate ] = Object.keys(availDate);
            if(availDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
            `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` ===  checkingDate )
                return availDate[ checkingDate ];
        });
        if(!available)
            return <span className="normal-date-cls disable-date-cls" disabled>{day}</span>
        if(available && !available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].status)
            return <span className="normal-date-cls disable-date-cls" disabled>{day}</span>
        else if (moment(date).format("L") == moment().format("L"))
            return day
        else if (moment(date).isBefore(moment()))
            return <span className="normal-date-cls disable-date-cls" disabled>{day}</span>
        else
            return <span className="normal-date-cls">{day}</span>;
    };

    const isDateAvailable = (date) => {
        if (!availableDates || availableDates.length === 0) return true;
        const available = availableDates.find(availDate => {
            const [checkingDate] = Object.keys(availDate);
            if (availDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
                `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` === checkingDate)
                return availDate[checkingDate];
        });
        if (!available || !available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`]?.status) {
            return false;
        }
        if (moment(date).isBefore(moment(), 'day')) {
            return false;
        }
        return true;
    };

    const handleOk = (date, dateObj) => {
        const selected = dateObj || date;
        if (!isDateAvailable(selected)) {
            notification.error({
                message: 'Date Unavailable',
                description: 'The selected date is not available. Please choose an available date.',
                duration: 4,
            });
            return;
        }
        if (urlUpdate) {
            dispatch(push(updateURLParameter(updateURLParameter(searchURLString, 'urlStartDate', moment(selected).format(CALENDER_DATE_FORMAT)), 'urlEndDate', moment(selected).format(CALENDER_DATE_FORMAT))));
        }
        onChange(moment(selected).format('MM/DD/YYYY'));
        setVisible(false);
    }

    useEffect(() => {
        if (locationPath?.includes('/dashboard')) {
            setVerify(true);
        }
    }, [locationPath]);

    return (
        <div>

            <DatePicker
                locales={'en-US'}
                defaultValue={selectedDate}
                id="inline-date-picker-portait"
                className="booking-range-picker guest-input"
                placeholder="Select a date"
                inline
                autoOk={true}
                displayMode={"portrait"}
                fullWidth={false}
                dateRenderer={dateRenderer}
                getDateClassName={getDateClassName}
                onChange={handleOk}
                icon={<img src={calendar} className="img" alt="calendar" />}
                cancelLabel={<span className="clear-all-btn" onClick={() => handleClearAll()}>Clear</span>}
                value={value}
                label={label}
                okLabel={verified ? <img src={greenTick} className="img" alt="calendar" /> : blueTick ? <img src={blueTick} className="img" alt="calendar" /> : 'Ok'}
            />
        </div>
    );
};

SingleDatePicker.propTypes = {
    setSelectedDate: PropTypes.string,
    selectedDate: PropTypes.array,
    handleDateChange: PropTypes.func,
    dateString: PropTypes.string,
}

export default SingleDatePicker;
